{
  "loading": "Laden...",
  "placeholder": "Auswählen…"
}
